module.exports = __webpack_public_path__ + "img/kyc.e8d67467.svg";